import { render, staticRenderFns } from "./DialogUploadImage.vue?vue&type=template&id=5732844f&scoped=true"
import script from "./DialogUploadImage.vue?vue&type=script&lang=js"
export * from "./DialogUploadImage.vue?vue&type=script&lang=js"
import style0 from "./DialogUploadImage.vue?vue&type=style&index=0&id=5732844f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5732844f",
  null
  
)

export default component.exports